import { BrowserRouter, useLocation } from 'react-router-dom'
import { ChatBot } from '@/components/ChatBot'
import { ChatBotProvider } from '@/contexts/ChatBotContext'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { CookieConsent } from '@/components/CookieConsent'
import { LanguageRouter } from '@/components/LanguageRouter'
import { ScrollToTop } from '@/components/ScrollToTop'
import { SkipLink } from '@/components/ui/SkipLink'

function ChatBotVisibility() {
  const location = useLocation()
  const pageSlug = location.pathname.split('/').filter(Boolean)[1]
  const isBookPage = pageSlug === 'prenota' || pageSlug === 'book'
  return isBookPage ? null : <ChatBot />
}

export default function App() {
  return (
    <BrowserRouter unstable_useTransitions={false}>
      <ScrollToTop />
      <SkipLink />
      <CookieConsentProvider>
        <ChatBotProvider>
          <LanguageRouter />
          <ChatBotVisibility />
          <CookieConsent />
        </ChatBotProvider>
      </CookieConsentProvider>
    </BrowserRouter>
  )
}
